module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "bar bar-nav"
  }, [_c('a', {
    staticClass: "icon icon-left pull-left",
    on: {
      "click": _vm.goBack
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("新增发票抬头")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "list-block"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("单位名称")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.addEnterprise),
      expression: "addEnterprise",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "open-popup open-enterprise",
    attrs: {
      "data-popup": ".popup-enterprise",
      "type": "text",
      "placeholder": "单位名称",
      "id": "enterpriseName",
      "readonly": "",
      "unselectable": "on"
    },
    domProps: {
      "value": (_vm.addEnterprise)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addEnterprise = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('li', {
    staticClass: "align-top"
  }, [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("设为默认")]), _vm._v(" "), _c('div', {
    staticClass: "item-input",
    staticStyle: {
      "margin-top": "1px",
      "margin-left": "45%"
    }
  }, [_c('label', {
    staticClass: "label-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isDefaultString),
      expression: "isDefaultString"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isDefaultString) ? _vm._i(_vm.isDefaultString, null) > -1 : (_vm.isDefaultString)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isDefaultString,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isDefaultString = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isDefaultString = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isDefaultString = $$c
        }
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-50"
  }, [_c('a', {
    staticClass: "button button-big button-fill button-danger",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("取消")])]), _vm._v(" "), _c('div', {
    staticClass: "col-50"
  }, [_c('a', {
    staticClass: "button button-big button-fill button-success",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确认")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d1ece11","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/User/MyInvoice/AddInvoiceTitle.vue
// module id = 1626
// module chunks = 8